import { TRPCClientError } from "@trpc/client";

export function isNetworkError(error: unknown): boolean {
	if (error instanceof TRPCClientError) {
		if (error.data && "code" in error.data && "path" in error.data) {
			if (
				error.data.code === "INTERNAL_SERVER_ERROR" ||
				error.data.code === "SERVICE_UNAVAILABLE" ||
				error.data.code === "TIMEOUT" ||
				error.data.code === "TOO_MANY_REQUESTS" ||
				error.data.code === "BAD_GATEWAY" ||
				error.data.code === "GATEWAY_TIMEOUT"
			) {
				return true;
			}
			return false;
		}
	}

	// ADD OTHER APPLICATION ERROR DETECTION HERE

	// default to true because:
	// - application errors should have a known structure that can be checked for
	// - whereas network errors are not structured and could take on many forms
	// - this helper is mostly used for offline sync logic, where false negatives are much worse than false positives.
	return true;
}

export function isInternalServerError(error: unknown): boolean {
	if (error instanceof TRPCClientError) {
		if (error.data && "code" in error.data && "path" in error.data) {
			if (error.data.code === "INTERNAL_SERVER_ERROR") {
				return true;
			}
			return false;
		}
	}

	return false;
}
